import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

/** One email, once, when FIFA publishes a new ranking and Kenya has moved. */
export const RankingAlertSignup = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [mailed, setMailed] = useState(true);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/ranking-alerts", { email });
      toast.success("You will hear the moment Kenya moves.");
      setEmail("");
      setMailed(Boolean(data?.email_sent));
      setDone(true);
    } catch {
      toast.error("That didn't send. Try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border-l-2 border-maasai bg-[#0b0b0b] p-6 md:p-8" data-testid="ranking-alert-signup">
      <p className="overline text-ochre">Ranking alerts</p>
      <h3 className="mt-4 font-display text-xl font-bold uppercase leading-tight text-white md:text-2xl">
        Hear It The Moment Kenya Moves
      </h3>
      <p className="mt-4 max-w-xl text-sm leading-relaxed text-zinc-400">
        FIFA publishes the world ranking four to eight times a year. Leave an address and you will get one email
        when the next release lands and Kenya&rsquo;s position or points have changed &mdash; the new number, the
        move, nothing else. Unsubscribe from any alert.
      </p>
      {done ? (
        <p className="mono mt-6 text-[0.6rem] uppercase leading-relaxed tracking-[0.16em] text-ochre" data-testid="ranking-alert-done">
          {mailed
            ? "You are on the list. Check your inbox for the confirmation."
            : "You are on the list. Our confirmation email did not go out, but the alert itself will."}
        </p>
      ) : (
        <form onSubmit={submit} className="mt-6 flex flex-col gap-3 sm:flex-row" data-testid="ranking-alert-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            data-testid="ranking-alert-input"
            className="min-w-0 flex-1 border border-white/20 bg-transparent px-4 py-3 text-sm text-white placeholder:text-zinc-400 focus:border-ochre focus:outline-none"
          />
          <button
            type="submit"
            disabled={busy}
            className="btn-primary justify-center disabled:opacity-60"
            data-testid="ranking-alert-submit"
          >
            {busy ? "Sending" : "Alert me"}
          </button>
        </form>
      )}
      <p className="mt-4 max-w-xl text-xs leading-relaxed text-zinc-500" data-testid="ranking-alert-consent">
        By leaving your address you agree to receive these ranking alerts. Unsubscribe from any alert. We never
        sell or share your address.{" "}
        <Link to="/privacy" className="text-ochre underline">How we use your data</Link>.
      </p>
    </div>
  );
};
